export default function (item) {
  return !!(
    item.imageProperties &&
    item.imageProperties.imageData &&
    item.imageProperties.imageData.image
  );
}
